<template>
	<div class="c-board-header" :style="style">
		<div class="c-board-header__screen"></div>
		<article>
			<h1>
				{{ board.name }}
			</h1>
			<span>
				<img
					:title="`${user.name}'s profile`"
					:src="`${assetUrl}/${user.avatar.name}`"
				/>
				By {{ user.name }} for
				{{ workspace.name }}
			</span>
			<div class="c-board-header__share" v-if="hasSocialLink">
				<a v-if="workspace.website" :href="workspace.website" target="_blank">
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M10 5.5L10.7514 4.75837C13.0959 2.41387 16.8971 2.41388 19.2416 4.75837C21.5861 7.10287 21.5861 10.9041 19.2416 13.2486L18.5 14M5.5 10L4.75837 10.7514C2.41387 13.0959 2.41388 16.8971 4.75838 19.2416C7.10287 21.5861 10.9041 21.5861 13.2486 19.2416L14 18.5M10 14L14 10"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						/>
					</svg>
					<span> Website </span>
				</a>
				<a v-if="workspace.linkedin" :href="workspace.linkedin" target="_blank">
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M19.65 3H4.35C3.99196 3 3.64858 3.14223 3.39541 3.39541C3.14223 3.64858 3 3.99196 3 4.35V19.65C3 20.008 3.14223 20.3514 3.39541 20.6046C3.64858 20.8578 3.99196 21 4.35 21H19.65C20.008 21 20.3514 20.8578 20.6046 20.6046C20.8578 20.3514 21 20.008 21 19.65V4.35C21 3.99196 20.8578 3.64858 20.6046 3.39541C20.3514 3.14223 20.008 3 19.65 3ZM8.4 18.3H5.7V10.2H8.4V18.3ZM7.05 8.625C6.74056 8.61616 6.4406 8.51632 6.18758 8.33797C5.93456 8.15962 5.7397 7.91066 5.62737 7.6222C5.51503 7.33374 5.49019 7.01857 5.55595 6.71607C5.6217 6.41358 5.77515 6.13716 5.9971 5.92138C6.21906 5.70559 6.49968 5.55999 6.80391 5.50278C7.10814 5.44556 7.42248 5.47927 7.70766 5.59969C7.99284 5.7201 8.23622 5.92189 8.40737 6.17983C8.57853 6.43778 8.66987 6.74044 8.67 7.05C8.66289 7.47331 8.4885 7.8766 8.18495 8.17173C7.88139 8.46685 7.47335 8.62982 7.05 8.625ZM18.3 18.3H15.6V14.034C15.6 12.756 15.06 12.297 14.358 12.297C14.1522 12.3107 13.9511 12.3649 13.7663 12.4566C13.5815 12.5482 13.4166 12.6755 13.2811 12.831C13.1457 12.9866 13.0422 13.1674 12.9768 13.363C12.9114 13.5586 12.8853 13.7652 12.9 13.971C12.8955 14.0129 12.8955 14.0551 12.9 14.097V18.3H10.2V10.2H12.81V11.37C13.0733 10.9695 13.435 10.6433 13.8605 10.4227C14.286 10.2021 14.761 10.0944 15.24 10.11C16.635 10.11 18.264 10.884 18.264 13.404L18.3 18.3Z"
							fill="currentColor"
						/>
					</svg>
					<span> Linkedin </span>
				</a>
				<a v-if="workspace.twitter" :href="workspace.twitter" target="_blank">
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M17.4033 3.5H20.2852L13.989 10.701L21.396 20.5H15.5964L11.054 14.557L5.85637 20.5H2.97269L9.70709 12.7977L2.60156 3.5H8.54839L12.6544 8.93215L17.4033 3.5ZM16.3918 18.7738H17.9887L7.68067 5.13549H5.96702L16.3918 18.7738Z"
							fill="currentColor"
						/>
					</svg>

					<span> X/Twitter </span>
				</a>
				<a v-if="workspace.youtube" :href="workspace.youtube" target="_blank">
					<svg
						width="24"
						height="24"
						viewBox="0 0 24 24"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							fill-rule="evenodd"
							clip-rule="evenodd"
							d="M20.2043 4.00776C21.1084 4.28763 21.8189 5.10925 22.0609 6.15475C22.4982 8.04786 22.5 12 22.5 12C22.5 12 22.5 15.9522 22.0609 17.8453C21.8189 18.8908 21.1084 19.7124 20.2043 19.9922C18.5673 20.5 12 20.5 12 20.5C12 20.5 5.43274 20.5 3.79568 19.9922C2.89159 19.7124 2.1811 18.8908 1.93908 17.8453C1.5 15.9522 1.5 12 1.5 12C1.5 12 1.5 8.04786 1.93908 6.15475C2.1811 5.10925 2.89159 4.28763 3.79568 4.00776C5.43274 3.5 12 3.5 12 3.5C12 3.5 18.5673 3.5 20.2043 4.00776ZM15.5134 12.0003L9.79785 15.2999V8.70065L15.5134 12.0003Z"
							fill="currentColor"
						/>
					</svg>

					<span> Youtube </span>
				</a>
			</div>
		</article>
	</div>
</template>

<script>
export default {
	props: {
		board: {},
	},

	computed: {
		style: function () {
			let hue = 0;
			let bgColor = `hsl(0, 0%, 10%)`;
			if (this.workspace.color) {
				hue = this.workspace.color;
				bgColor = `hsl(var(--hue), 100%, 58%)`;
			}

			return {
				'--hue': `${hue}`,
				'--bgColor': `${bgColor}`,
			};
		},
		hasSocialLink: function () {
			let workspace = this.workspace;
			if (
				workspace.website ||
				workspace.linkedin ||
				workspace.twitter ||
				workspace.youtube
			) {
				return true;
			}

			return false;
		},
		assetUrl: function () {
			return this.$store.getters['config/assetUrl'];
		},
		slug: function () {
			return this.$route.params.slug;
		},
		board: function () {
			if (!this.slug) {
				return;
			}
			return this.$store.getters['boards/boardBySlug'](this.slug);
		},
		user: function () {
			return this.$store.getters['users/user'];
		},
		workspace: function () {
			return this.$store.getters['workspaces/all'];
		},
	},
};
</script>

<style lang="scss">
.c-board-header {
	position: relative;
	text-align: center;

	&__screen {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: calc(100% + 12rem);
		background-color: var(--bgColor);

		&:after {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			background: linear-gradient(
				0deg,
				rgba(255, 255, 255, 0) 0%,
				rgba(255, 255, 255, 0.14) 100%
			);
			pointer-events: none;
		}
	}

	article {
		position: relative;
		z-index: 1;
		max-width: 400px;
		margin: 0 auto;
		padding-top: 2rem;
	}

	h1 {
		font-family: var(--font-family);
		font-weight: 500;
		color: #fff;
	}

	span {
		display: inline-flex;
		align-items: center;
		color: #fff;
		font-weight: 400;
		font-size: var(--font-size-sm);

		strong {
			display: inline;
		}

		img {
			width: 32px;
			height: 32px;
			border-radius: 99px;
			object-fit: cover;
			object-position: center center;
			margin-right: var(--margin-lg);
		}
	}

	&__share {
		display: flex;
		align-items: center;
		justify-content: center;
		margin-top: 1rem;

		a {
			display: inline-flex;
			align-items: center;
			padding: 0.25rem;
			padding-right: 0.5rem;
			border-radius: 5px;
			font-size: var(--font-size-sm);
			color: #fff;
			margin-right: var(--margin);
			text-decoration: none !important;

			svg {
				margin-right: var(--margin);
			}

			&:last-child {
				margin-right: 0;
			}

			&:hover,
			&:active {
				background-color: rgba(255, 255, 255, 0.2);
			}
		}
	}

	@media screen and (max-width: 410px) {
		&__share {
			display: grid;
			padding: 0 var(--margin);
			grid-template-columns: 1fr 1fr;
			grid-template-rows: 1fr 1fr;
			a {
				display: flex;
			}
		}
	}
}
</style>
